import { Country } from '@/models/country';

import { Event } from './event';

export class CountriesAcquiredEvent extends Event<Readonly<Country[]>> {}
